import styled from "styled-components";

interface IMainButton {
  isLoading?: any;
}
export const MainButton = styled.button<IMainButton>`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    cursor: ${props.isLoading ? "not-allowed" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  color: ${(props) => props.theme.colors.white};
  align-items: center;
  border: none;
  border-radius: 8px;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  height: 6.4rem;
  justify-content: center;
  width: 34.8rem;

  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) =>
      theme.colors.accentGreen + theme.transparencies.p20};
    cursor: not-allowed;
  }

  .icon {
    height: 5rem;
    width: 5rem;
  }
`;

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  align-items: center;
  border-radius: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  max-height: 82vh;
  overflow-y: auto;
  padding: 4rem;
  width: 78rem;

  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 0;
  }

  .rows-wrapper {
    margin-bottom: 5rem;
    margin-top: 3.5rem;
    width: 96%;
  }

  .option-container {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    align-items: center;
    display: flex;
    font-size: 1.4rem;
    font-weight: 500;

    input {
      margin-right: 1.5rem;
      margin-top: -0.1rem;
    }
  }
  .bankLogo {
    display: flex;
    justify-content: center;
    margin-left: 0.3rem;
  }

  .currency--container {
    margin-top: 2rem;
    width: 67.1rem;
  }

  .clickable-element {
    cursor: pointer;
  }
`;

export const InvoicesContainer = styled.div`
  margin-top: 4rem;
  width: 67.1rem;
`;
export const InvoiceContainer = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  border-radius: 8px;
  box-shadow: 0px 5px 50px rgb(231 231 234 / 62%);
  font-size: 1.4rem;
  margin-bottom: 0.8rem;
  padding: 1.5rem;

  div {
    display: flex;
  }
  .volante-id {
    background-color: ${(props) =>
      props.theme.colors.primaryBlue + props.theme.transparencies.p10};
    color: ${(props) => props.theme.colors.primaryBlue};
    border-radius: 8px;
    font-size: 1.4rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    padding: 0.6rem;
  }
  .invoice-id {
    ${(props) => `
      color: ${props.theme.colors.blackTextTitle};
    `}
    font-weight: 600;
    margin-bottom: 0;
  }
  .importer {
    color: ${(props) =>
      props.theme.colors.blackTextTitle + props.theme.transparencies.p58};
    font-weight: 500;
    margin-bottom: 0;
  }
`;

export const PaymentContainer = styled.div`
  ${(props) => `
  font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  font-size: 1.2rem;
  width: 67.1rem;

  .special-row {
    ${(props) => `
    background-color: ${props.theme.colors.primaryBlue};
  `}
    color: ${(props) => props.theme.colors.white};
    border-radius: 8px;
    display: flex;
    font-weight: 600;
    justify-content: space-between;
    padding: 0 1rem;

    p:nth-of-type(2) {
      ${(props) => `
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
      font-weight: 800;
    }
  }
  .icon {
    height: 4rem;
    width: 5rem;
  }
`;

export const Row = styled.div`
  ${(props) => `
  font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: flex-start;
  border-radius: 8px;
  box-shadow: 0px 5px 50px rgb(231 231 234 / 62%);
  display: flex;
  flex-direction: column;
  margin-bottom: 0.8rem;
  padding: 2.4rem;

  p {
    color: ${(props) => props.theme.colors.blackTextTitle};
    font-size: 1.4rem;
    font-weight: 500;
    margin: 0;
  }

  h2 {
    color: ${(props) =>
      props.theme.colors.blackTextBody + props.theme.transparencies.p30};
    font-size: 1.4rem;
    font-weight: 700;
  }

  .row-title {
    margin-bottom: 1.6rem;

    p {
      font-weight: 700;
    }
  }

  .bank-selectors {
    display: flex;
  }

  .bank-numbers {
    display: flex;
    justify-content: space-between;
    margin-top: 2rem;
    width: 100%;

    p {
      font-size: 1.6rem;
    }
  }

  .operation-info {
    width: 100%;
  }

  .bank-styles-select-button .p-button.p-highlight {
    background: #ffffff;
    border-color: #002e6c;
    border-radius: 10px;
    color: #ffffff;
  }
  .bank-styles-select-button .p-button.p-highlight:hover {
    background: #ffffff;
    border-color: #ffffff;
    color: #ffffff;
  }
  .bank-styles-select-button .p-button {
    border: 0px solid #ced4da;
    margin-right: 2.2rem;
  }
  .bank-styles-select-button
    .p-button:not(.p-disabled):not(.p-highlight):hover {
    background: #f2f3f8;
    border-color: #ced4da;
    border-radius: 10px;
    color: #495057;
    margin-right: 2rem;
  }
  .bank-styles-select-button .p-button:not(:first-of-type):not(:last-of-type) {
    border-radius: 10px;
  }
  .bank-styles-select-button .p-button .css-151u0ei-IconButton {
    -ms-flex-align: center;
    -ms-flex-pack: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    align-items: center;
    background-color: #f7f8fb;
    border-radius: 8px;
    border: none;
    color: black;
    cursor: pointer;
    display: -ms-flexbox;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    font-family: "Montserrat", sans-serif;
    font-size: 1.4rem;
    font-weight: 600;
    height: 5rem;
    justify-content: center;
    justify-content: center;
    margin-right: 0rem;
    width: 11rem;
  }
  .bank-styles-select-button .p-button:focus {
    box-shadow: 0 0 0 0rem #002e6c;
    outline-offset: 0;
    outline: 0 none;
  }
  .bank-styles-select-button .p-button .css-17jcnob-IconButton {
    -ms-flex-align: center;
    -ms-flex-pack: center;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    align-items: center;
    background-color: #002e6c;
    border-radius: 8px;
    border: none;
    color: black;
    cursor: pointer;
    display: -ms-flexbox;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    font-family: "Montserrat", sans-serif;
    font-size: 1.4rem;
    font-weight: 600;
    height: 5rem;
    justify-content: center;
    margin-right: 0rem;
    width: 11rem;
  }
  .bank-styles-select-button .p-button .css-13u13g6-IconButton {
    margin-right: 0rem;
  }
  .bank-styles-select-button .p-button .css-10kwezq-IconButton {
    margin-right: 0rem;
  }
`;
interface IIconButton {
  selected?: any;
}
export const IconButton = styled.button<IIconButton>`
  ${(props) => `
    background-color: ${
      props.selected
        ? props.theme.colors.primaryBlue
        : props.theme.colors.backgroundGray3
    };
    font-family: ${props.theme.fontFamilies.primaryFont};
    `}
  align-items: center;
  border-radius: 8px;
  border: none;
  color: black;
  cursor: pointer;
  display: flex;
  font-size: 1.4rem;
  font-weight: 600;
  height: 5rem;
  justify-content: center;
  margin-right: 2.2rem;
  width: 10rem;

  img {
    height: 60%;
    width: 80%;
  }
`;

export const DivIsLoading = styled.div`
  color: rgba(46, 53, 61, 0.3);
  font-size: 1.2rem;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  display: flex;
  justify-content: center;
  width: 60rem;
  .icon {
    height: 9rem;
    width: 9rem;
  }
`;
interface IButtonWhiteConfigurate {
  backgroundColor?: string;
  fontSize?: string;
  fontWeight?: string | number;
  marginTop?: string;
  minHeight?: string;
  width?: string;
  marginRight?: string;
}
export const ButtonWhiteConfigurate = styled.button<IButtonWhiteConfigurate>`
  ${(props) => `
    background-color: ${
      props.backgroundColor
        ? props.backgroundColor
        : props.theme.colors.primaryBlue
    };
    color: ${props.color ? props.color : props.theme.colors.white};
    cursor: ${props.disabled ? "not-allowed" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
    font-size: ${props.fontSize ? props.fontSize : "1.5em"};
    font-weight: ${props.fontWeight ? props.fontWeight : "700"};
    margin-right: ${props.marginRight ? props.marginRight : "0rem"};
    margin-top:${props.marginTop ? props.marginTop : "0rem"};
    min-height:${props.minHeight ? props.minHeight : "3rem"};
    width:${props.width ? props.width : "32.4rem"};
    `}
  align-items: center;
  border-radius: 8px;
  border: 1px solid;
  display: flex;
  justify-content: center;
`;

export const DashedRowVoucher = styled.div`
  align-items: center;
  color: ${(props) => props.theme.colors.blackTextTitle};
  display: flex;
  flex-direction: column;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.2rem;
  font-weight: 500;
  padding: 3rem 0;
  row-gap: 0.8rem;
  text-align: center;
`;

interface IRowContainerVoucher {
  height?: string;
  width?: string;
}
export const RowContainerVoucher = styled.div<IRowContainerVoucher>`
  border-radius: 8px;
  border: 2px dashed #002e6c;
  cursor: pointer;
  height: ${(props) => (props.height ? props.height : "5rem")};
  width: ${(props) => (props.width ? props.width : "25rem")};
  p {
    font-family: ${(props) => props.theme.fontFamilies.primaryFont};
    font-size: 1.4rem;
  }
  img {
    padding: 0.5rem;
  }
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const FileInfoVoucher = styled.div`
  align-items: center;
  border-color: transparent;
  border-radius: 8px;
  border: none;
  box-shadow: 0px 5px 20px rgb(231 231 234 / 62%);
  display: flex;
  font-size: 1.4rem;
  font-weight: 600;
  justify-content: space-between;
  padding: 0 1rem;
  width: 100%;

  .delete-icon {
    filter: invert(0%) sepia(0%) saturate(0%) hue-rotate(106deg) brightness(30%)
      contrast(105%);
  }

  p {
    margin-left: 1rem;
  }
  .size {
    color: ${(props) => props.theme.colors.gray72};
    font-weight: 500;
  }
`;

export const DivBank = styled.div`
  align-items: center;
  background: #ffffff;
  border-color: transparent;
  border-radius: 8px;
  border: none;
  box-shadow: 0px 5px 20px rgba(231, 231, 234, 0.4);
  display: flex;
  flex-direction: column;
  font-size: 1.4rem;
  font-weight: 600;
  justify-content: center;
  margin-right: 1rem;
  padding: 0 1rem;
  width: 10.2rem;
`;

export const DivImageSize = styled.div`
  .icon-image-bank {
    height: 3rem;
    width: 6rem;
  }
`;

export const DivSelectMoney = styled.h3`
  color: rgba(46, 53, 61, 0.3);
  font-size: 1.2rem;
  font-weight: 700;
`;

export const DivVolanteId = styled.div`
  align-items: center;
  background: rgba(48, 52, 92, 0.1);
  border-radius: 7px;
  box-shadow: 0px 5px 30px rgba(231, 231, 234, 0.62);
  color: #30345c;
  display: flex;
  font-size: 1.4rem;
  font-weight: 600;
  justify-content: center;
  padding: 1.3rem;
`;

export const DivRucFac = styled.div`
  color: rgba(8, 8, 43, 0.4);
  font-size: 1.4rem;
  font-weight: 600;
  margin-top: 0.5rem;
`;
export const DivRucName = styled.div`
  color: rgba(8, 8, 43, 0.4);
  font-size: 1.4rem;
  font-weight: 500;
  margin-top: 0.5rem;
  text-align: end;
`;

export const DivFlexRuc = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

export const DivVouchers = styled.div`
  color: #000000;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.4rem;
  font-weight: 700;
  margin-bottom: 1rem;
`;

export const DivFlexBetween = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const DivPaymentVoucher = styled.div`
  align-items: center;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 5px 50px rgba(231, 231, 234, 0.62);
  display: flex;
  height: 6.4rem;
  justify-content: space-between;
`;

export const DivAddPaymentVoucher = styled.div`
  color: #000000;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.4rem;
  font-weight: 700;
  margin-left: 2.4rem;
`;
